export default {"src":"/_next/static/media/grundriss-schwarz.5a832566.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};